import { setStyleProperty } from './utils/setStyleProperty'

export default class Collapse {
    els = {
        toggleBtn: '.custom-toggle-collapse[data-collapse="button"]',
        container: '.custom-collapse__body[data-collapse="body"]',
        childNode: '.filter__btn',
        toggleBtnText: '.custom-toggle-collapse[data-collapse="button"] .custom-toggle-collapse__text'
    };

    stateClasses = {
        collapseBodyClosed: 'custom-collapse__body_open',
        mainCollapseClosed: 'collapsed-card',
        overflowHidden: 'catalog__filter--list_overflow'
    }

    constructor() {
        this.defaultHeight = 0;
        this.collapseBtns = document.querySelectorAll(this.els.toggleBtn);
        this.collapseTargets = document.querySelectorAll(this.els.container);

        if (this.collapseBtns.length > 0) {
            this.bindEvents()
        }
    }

    initialState(collapseTarget) {
        setTimeout(() => {
            setStyleProperty(collapseTarget, 'transition', 'max-height 0.5s')
        }, 400)
    }

    setCollapseHeight(collapseTarget) {
        this.defaultHeight = collapseTarget.scrollHeight;
        setStyleProperty(collapseTarget, '--collapse-open', `${ this.defaultHeight + 20 }px`)
    }

    toggleButton(toggleBtn) {
        const spanElement = toggleBtn.querySelector('.custom-toggle-collapse__text');

        let newText = spanElement.dataset.collapse_toggle_text,
            prevText = spanElement.innerHTML;

        spanElement.classList.toggle('toggle-btn_close')

        if (!newText) {
            return;
        }

        spanElement.innerHTML = newText;
        spanElement.dataset.collapse_toggle_text = prevText;
    }

    toggleOverflowHidden(collapseTarget) {
        collapseTarget.classList.contains(this.stateClasses.overflowHidden)
            ?
            setTimeout(() => {
                collapseTarget.classList.toggle(this.stateClasses.overflowHidden)
            }, 500)
            :
            collapseTarget.classList.toggle(this.stateClasses.overflowHidden)
    }

    collapse(initialToggle, collapseTarget, collapseButton) {
        this.setCollapseHeight(collapseTarget);
        collapseTarget.classList.toggle(this.stateClasses.collapseBodyClosed);
        this.toggleOverflowHidden(collapseTarget);


        if (initialToggle) {
            this.toggleButton(collapseButton)
        }
    }

    init() {
        this.collapseBtns.forEach((node) => {
            // Button
            const buttonId = node.dataset.collapseId;
            // Container
            const collapseTarget = Array.from(this.collapseTargets).find((item) => item.dataset.collapseId === buttonId)

            node.addEventListener('click', () => {
                this.collapse(true, collapseTarget, node)
            })

            this.initialState(collapseTarget)
        })
    }

    bindEvents() {
        this.init();
    }
}

export class TableCollapse {
    constructor() {
        this.bindEvents()
    }

    initCollapse() {
        $('[data-init-collapse]').CardWidget();
    }

    bindEvents() {
        $(document).on('trigger::newCatalogTable', this.initCollapse)
    }
}

